import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { unfolder, urlValue, useTranslate } from '../lib';

const SearchLob = ({ onLobSelect, searchResultsContainer, showSearch, setShowSearch }) => {
  const [subCampaigns, setSubCampaigns] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslate();
  const containerRef = useRef(null);

  const fetchSubCampaigns = async (term) => {
    try {
      setLoading(true);
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey')?.token;
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')?.id;

      // studio/project/camp/subcampaings
      const res = await axios.get(`${urlValue}/studio/project/camp/subcampaings`, {
        params: { q: term || '' },
        headers: { user: id, 'access-token': token },
        withCredentials: true
      });

      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setSubCampaigns(data);
    } catch (err) {
      console.error('Error loading subcampaigns', err);
      setSubCampaigns([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!showSearch) return;
    const t = setTimeout(() => fetchSubCampaigns(search), 300);
    return () => clearTimeout(t);
  }, [search, showSearch]);

  useEffect(() => {
    if (!showSearch) {
      setSearch('');
      setSubCampaigns([]);
    }
  }, [showSearch]);

  const handlePick = async (subCampaign) => {
    try {
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey')?.token;
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')?.id;
      const commonCfg = { headers: { user: id, 'access-token': token }, withCredentials: true };

      const res = await axios.get(`${urlValue}/studio/project/camp/subcampaign/${subCampaign.id}/projects`, commonCfg);
      console.log('res.data', res.data)
      const normalize = (payload) => {
        const body = payload ?? [];
        return Array.isArray(body) ? body
          : Array.isArray(body?.data) ? body.data
          : Array.isArray(body?.projects) ? body.projects
          : Array.isArray(body?.data?.projects) ? body.data.projects
          : Array.isArray(body?.rows) ? body.rows
          : [];
      };

      const raw = normalize(res?.data);

      const projects = raw.map(p => ({
        id: p?.id ?? p?.project_id ?? p?.project?.id,
        name: p?.name ?? p?.project_name ?? p?.project?.name,
        type: p?.type ?? p?.project?.type ?? null,
      })).filter(x => x.id && x.name);

      if (!projects.length) {
        alert('No projects available for this subcampaign.');
        return;
      }

      onLobSelect?.({ subCampaign, projects });
      setShowSearch(false);
    } catch (e) {
      console.error('Error loading projects by subcampaign', e);
    }
  };

  if (!showSearch) return null;

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        width: '100%',
        background: 'white',
        padding: 10,
        borderRadius: 10,
        boxShadow: '1px 1px 3px rgba(0,0,0,.35)',
        marginTop: 10,
        zIndex: 1000
      }}
    >
      <div style={{ fontSize: 9, color: '#535353', textTransform: 'uppercase', marginTop: 5 }}>
        {t('menu.searchBySubCampaign') || 'Search by Subcampaign (LOB)'}
      </div>

      <h6 style={{ fontSize: 14, marginTop: 5 }}>
        {t('menu.searchSubCampaigns') || 'Buscar subcampañas (LOBs)'}:
      </h6>

      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={t('menu.typeSubCampaignName') || 'Subcampaign name'}
        style={{ width: '100%', padding: 10, fontSize: 12, borderRadius: 5, marginTop: 10 }}
        autoFocus
      />

      {loading && <div style={{ textAlign: 'center', padding: 10 }}>{(t('common.searching') || 'Searching') + '...'}</div>}

      {!loading && subCampaigns.length > 0 && (
        <div style={{ marginTop: 10, maxHeight: 300, overflowY: 'auto' }}>
          {subCampaigns.map((s) => (
            <div
              key={s.id}
              onClick={() => handlePick(s)}
              style={{ padding: 8, cursor: 'pointer', borderBottom: '1px solid #eee', marginTop: 10 }}
            >
              <div style={{ fontWeight: 600 }}>{s.name}</div>
              <div style={{ fontSize: 12, color: '#666' }}>ID: {s.id}</div>
            </div>
          ))}
        </div>
      )}

      {!loading && subCampaigns.length === 0 && (
        <div style={{ fontSize: 12, color: '#666', marginTop: 10 }}>
          {t('common.noResults') || 'Sin resultados'}
        </div>
      )}

      {searchResultsContainer && <div ref={searchResultsContainer} />}
    </div>
  );
};

export default SearchLob;
